import { render, staticRenderFns } from "./share_xt.vue?vue&type=template&id=3f90773a&scoped=true&"
import script from "./share_xt.vue?vue&type=script&lang=js&"
export * from "./share_xt.vue?vue&type=script&lang=js&"
import style0 from "./share_xt.vue?vue&type=style&index=0&id=3f90773a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90773a",
  null
  
)

export default component.exports